import { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";

const NotificationContext = createContext();

const BASE_URL = process.env.REACT_APP_API_URL;

export const NotificationProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadStatus = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/notifications`);
      const unread = res.data.filter((n) => !n.isRead);
      setUnreadCount(unread.length);
    } catch (err) {
      console.error("Failed to fetch notification status", err);
    }
  };

  useEffect(() => {
    // Check for low stock on mount (Daily check)
    const checkLowStock = async () => {
      try {
        await axios.post(`${BASE_URL}/api/notifications/check-low-stock`);
        fetchUnreadStatus(); // Refresh status after check
      } catch (err) {
        console.error("Failed to check low stock", err);
      }
    };
    checkLowStock();

    let interval;

    const startPolling = () => {
      fetchUnreadStatus();
      interval = setInterval(fetchUnreadStatus, 60000); 
    };

    const stopPolling = () => {
      clearInterval(interval);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startPolling();
      } else {
        stopPolling();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    if (document.visibilityState === "visible") {
      startPolling();
    }

    return () => {
      stopPolling();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <NotificationContext.Provider value={{ unreadCount, setUnreadCount, fetchUnreadStatus }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => useContext(NotificationContext);
